<ds-modal [modal]="modal" [title]="'label_add_digital_property' | translate" [maxWidthPercentage]="80" (modalClosed)="onCancel()">
  <div class="modal-content-wrapper">
    @if (digitalAssetFormUpdateEnabled()) {
      <p class="margin-bottom-md" data-test-id="required-fields-label-modal">
        {{ 'required_fields_label' | translate }}
      </p>
    }
    <app-add-digital-property
      [tenantId]="tenantId"
      [modalMode]="true"
      (cancelled)="onCancel()"
      (save)="onDigitalPropertyAdded($event)"
    >
    </app-add-digital-property>
  </div>
</ds-modal>
